const ToFixed = (number: number, toFixed: number = 1) => {
    if (typeof number == 'string') number = parseFloat(number);
    if (isNaN(number)) return undefined;
    return number % 1 == 0 ? number : number.toFixed(toFixed);
}

const FormatStringNumber = (string: string) => {
    return string.replaceAll(',', '.');
}

export default { ToFixed, FormatStringNumber };